// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__3KgtN","itemTitle":"ClientEmergencyInfo_itemTitle__1nqSo","itemText":"ClientEmergencyInfo_itemText__1HTd8"};